export const setLocation = ({ commit }, data) => {
  commit('setLocation', data)
}
export const setUserInfo = ({ commit }, data) => {
  commit('setUserInfo', data)
}